export default function getNeatNotes(data){
    return data==null? "Nothing to show" : data;
}